<template>
  <appear v-if="seoCategories.length">
    <b-container id="listings-seo-category-links" class="mt-5 pt-3 pb-5">
      <b-row>
        <b-col>
          <h2 class="header-md mb-4">
            Find the perfect {{ isRoomsOffering ? 'Room' : 'Home' }} for You in the
            {{ market.displayName }}
          </h2>
          <div class="my-3" v-for="category in seoCategories" :key="category">
            <h3 class="header-sm text-capitalize mb-3">{{ category }}</h3>
            <b-row>
              <b-col
                cols="6"
                xl="4"
                class="line-height-18 pb-3 pb-md-0"
                v-for="item in contentJSON[category]"
                :key="item"
              >
                <a class="font-small hyperlink" :href="buildLinkFromItem(category, item)">
                  {{ item }}
                </a>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </appear>
</template>

<script>
import { sortBy, kebabCase } from 'lodash-es'
import { CONTENT_TYPES } from '@/constants/contentful.js'

export default {
  name: 'SEOCategoryLinks',
  props: {
    market: {
      type: Object,
      required: true,
    },
    isRoomsOffering: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      contentJSON: {},
      categoryOrder: ['neighborhoods', 'features', 'landmarks', 'schools', 'zip'],
    }
  },
  async created() {
    this.fetchSEOLinks()
  },
  computed: {
    listingsBaseURL() {
      const baseURL = process.env.VUE_APP_FRONTEND_URL
      const homeType = this.isRoomsOffering ? 'rooms-for-rent' : 'homes-for-rent'
      const marketSlug = this.market?.slug

      return `${baseURL}/${homeType}/${marketSlug}`
    },
    seoCategories() {
      const categories = Object.keys(this.contentJSON)
      return sortBy(categories, (category) => this.categoryOrder.indexOf(category))
    },
  },
  methods: {
    buildLinkFromItem(category, item) {
      // Retain curreny symbol (if detected)
      const slug = item?.includes('$') ? kebabCase(item).replace('-', '-$') : kebabCase(item)

      return `${this.listingsBaseURL}/${category}/${slug}`
    },
    async fetchSEOLinks() {
      try {
        const response = await this.$contentful.getEntries({
          content_type: CONTENT_TYPES.jsonBlob,
          'fields.marketSlug': this.market.slug,
        })
        this.contentJSON = response?.items[0]?.fields?.json || {}
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>
